import table from './table'

export default {
    id: 'Zahlungslauf #{id}',

    changeDataWarning: 'Wenn Zahlungsdaten (betrifft nicht "Interner Kommentar") geändert werden, werden automatisch die Dokumente neu generiert.',

    formProcesses: 'Formulare',
    payments: 'Zahlungen',

    organisation_id: 'Verband-ID',
    funding_program_id: 'Förderprogramm-ID',
    year_id: 'Jahr',
    year: 'Jahr',
    user_id: 'Nutzer-ID',
    pdf_document_id: 'PDF-Dokument-ID',
    xml_document_id: 'XML-Dokument-ID',

    organisation_name: 'Verband',
    organisationName: 'Verband',
    sum: 'Gesamtbetrag',
    iban: 'IBAN',
    account_holder: 'Kontoinhaber',
    accountHolder: 'Kontoinhaber',
    booking_date: 'Buchungsdatum',
    bookingDate: 'Buchungsdatum',
    search: 'Such-Spalte',

    intended_use: 'Verwendungszweck',
    intendedUse: 'Verwendungszweck',
    percentage: 'Prozentsatz',
    comment: 'Interner Kommentar',

    is_sage_export: 'SAGE-Export',
    status: 'Status',

    subsidy_due: 'Zuschuss',

    saveSuccess: 'Zahlungslauf erfolgreich gespeichert',

    exportSage: 'Nach SAGE exportieren',
    exportSuccess: 'Zahlungslauf erfolgreich exportiert',
    exportError: 'Fehler beim Exportieren des Zahlungslaufs',

    exportStatuses: {
        pending: 'Ausstehend',
        exported: 'Exportiert',
        failed: 'Fehlgeschlagen',
    },

    table,

    menu: {
        paymentRunBaseData: 'Daten',
        paymentRunPayments: 'Zahlungen',
        paymentRunActivities: 'Historie',
    }
}